module.exports = __webpack_public_path__ + "static/media/pinterest-square.02432135.svg";